// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2AkrT","label":"Completed_label__3Qyd7"};